module.exports = __webpack_public_path__ + "images/disabled-add-icon.svg";